import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const SkeletonCargandoInformacionContactoFiscal = () => {
    return (
        <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
            <div
                style={{
                    width: "100%",
                    maxWidth: 1200,
                    background: "#transparent",
                    borderRadius: 8,
                    border: "1px solid #e3e3e3",
                    boxShadow: "0 2px 8px #0001",
                    padding: 20,
                }}
            >
                <Row>
                    <Col className="col-lg-6 col-12">
                        <div className="mb-3">
                            <Skeleton width={250} height={20} className="mb-2" />
                        </div>
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0",
                                    borderBottom: i < 5 ? "1px solid #f3f3f3" : "none",
                                }}
                            >
                                <div style={{ flex: 1 }}>
                                    <Skeleton height={16} width="60%" />
                                </div>
                                <div style={{ flex: 2 }}>
                                    <Skeleton height={16} width="80%" />
                                </div>
                            </div>
                        ))}
                    </Col>
                    <Col className="col-lg-6 col-12">
                        <div className="mb-3">
                            <Skeleton width={200} height={20} className="mb-2" />
                        </div>
                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0",
                                    borderBottom: i < 4 ? "1px solid #f3f3f3" : "none",
                                }}
                            >
                                <div style={{ flex: 1 }}>
                                    <Skeleton height={16} width="50%" />
                                </div>
                                <div style={{ flex: 2 }}>
                                    <Skeleton height={16} width="70%" />
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default SkeletonCargandoInformacionContactoFiscal;